const RECOVERABLE_TECHNICAL_BLOCK =
  /(?:maximum execution attempts reached|bounded autonomous recovery exhausted|recoverable model planning failure|pre_execution_|corrective_plan_|planning-validation:|failed governed tool action|filesystem replacement target was not found|mutation failure|artifact failure|workspace failure|failed-artifact integration failure)/i;

/**
 * Runtime upgrades may reopen bounded technical implementation failures.
 * Authority, approval, security, and destructive-operation blocks are excluded
 * by using a narrow allowlist instead of treating every BLOCKED job as retryable.
 */
export function isRuntimeUpgradeRecoverableBlock(summary: string): boolean {
  return RECOVERABLE_TECHNICAL_BLOCK.test(summary);
}
